import Image from 'next/image';

import { MATRIX_GREEN } from '../constants';

const GAMES = [
  { name: 'Valorant', src: '/images/Valorant.webp' },
  { name: 'CS2', src: '/images/CS2.webp' },
  { name: 'Fortnite', src: '/images/Fortnite.webp' },
  { name: 'Dota 2', src: '/images/Dota2.webp' },
  { name: 'World of Warcraft', src: '/images/World of Warcraft.webp' },
  { name: 'Final Fantasy XIV', src: '/images/Final Fantasy XIV.webp' },
  { name: 'Rainbow Six Siege', src: '/images/Rainbow Six Siege.png' },
  { name: 'Escape From Tarkov', src: '/images/Escape From Tarkov.webp' },
  { name: 'Ragnarok', src: '/images/Ragnarok.webp' },
  { name: 'Tibia', src: '/images/Tibia.png' },
  { name: 'StarCraft', src: '/images/StarCraft.webp' },
  { name: 'Albion', src: '/images/Albion.png' },
  { name: 'Lineage II', src: '/images/Lineage II.webp' },
];

export function GameCarousel() {
  const items = [...GAMES, ...GAMES];

  return (
    <div className='relative w-full overflow-hidden' style={{ maskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)', WebkitMaskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)' }}>
      <div className='lp-game-track flex items-center'>
        {items.map((game, i) => (
          <div key={`${game.name}-${i}`} className='mx-3 w-[180px] shrink-0'>
            <div className='flex flex-col items-center gap-2 overflow-hidden rounded-xl border bg-[#0A0F0A] p-2.5 transition-all duration-200 hover:border-[#93FF18]/50' style={{ borderColor: `${MATRIX_GREEN}20` }}>
              <div className='relative h-[200px] w-[150px] overflow-hidden rounded-lg'>
                <Image src={game.src} alt={game.name} fill className='object-cover' sizes='150px' />
              </div>
              <span className='w-full truncate text-center font-mono text-[12px] font-semibold text-white/80' style={{ fontFamily: 'var(--font-jetbrains), monospace' }}>
                {game.name}
              </span>
            </div>
          </div>
        ))}
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html: `
        .lp-game-track {
          animation: lp-scroll-games 38s linear infinite;
          width: max-content;
        }
        .lp-game-track:hover {
          animation-play-state: paused;
        }
        @keyframes lp-scroll-games {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        /* transform is physical — CSS never mirrors it for writing direction. The track is
           width: max-content inside a narrower clip box, so under the dir="rtl" that /sa inherits
           from <html> the over-constrained box anchors to the RIGHT edge and overflows left, and the
           negative shift drags the strip out of the clip box instead of through it. Mirrored keyframes
           shift positive; only animation-name is overridden. */
        @keyframes lp-scroll-games-rtl {
          0% { transform: translateX(0); }
          100% { transform: translateX(50%); }
        }
        [dir='rtl'] .lp-game-track {
          animation-name: lp-scroll-games-rtl;
        }
      `,
        }}
      />
    </div>
  );
}
